export const filterConstructionTypes = (collection = [], searchTerm = '') => {
  if (!searchTerm?.trim()) return collection;

  const normalized = searchTerm.trim().toLowerCase();

  return collection.filter((item) => {
    const name = String(item?.name || '').toLowerCase();
    const description = String(item?.description || '').toLowerCase();
    const planName = String(item?.plan_name || '').toLowerCase();

    return (
      name.includes(normalized) ||
      description.includes(normalized) ||
      planName.includes(normalized)
    );
  });
};
